import { render, staticRenderFns } from "./music-btn.vue?vue&type=template&id=32736464&scoped=true&"
import script from "./music-btn.vue?vue&type=script&lang=js&"
export * from "./music-btn.vue?vue&type=script&lang=js&"
import style0 from "./music-btn.vue?vue&type=style&index=0&id=32736464&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32736464",
  null
  
)

export default component.exports